<template>
  <div class="GlobalTable">
    <div class="button_top">
      <div>
        <el-button size="small" type="success" @click="clickExcel">导出excel</el-button>
      </div>
    </div>
    <div style="    margin-bottom: 10px;
    color: rgb(255, 104, 123);font-size: 14px;">
      充值记录分为两种方式通知：到账时主动通知和主动查询；系统将每5分钟查询一次当日记录，凌晨12点时查询昨日记录</div>
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="交易流水号" slot="bizType" align="center">
        <template slot-scope="{ row }">
          <span>{{row.outUniqNo||"- -"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column label="收款银行" slot="relationNo" align="center">
        
          <template slot-scope="{ row }">
          <div>{{ row.payeeBankOpening||"- -" }}</div>
        </template>
   
      </el-table-column>
      <el-table-column label="收款账号" slot="bankAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payeeBankCard||"- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="付款账号" slot="payAccount" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.payerBankCard||"- -" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="交易信息来源" slot="getWay" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.getWay=='00'">主动查询</div>
          <div v-if="row.getWay=='01'">微众通知</div>
        </template>
      </el-table-column>
      <el-table-column label="商户类型" slot="accountType" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.accountType=='merchant'">回收商</div>
          <div v-if="row.accountType=='company'">门店商</div>
        </template>
      </el-table-column>
      <el-table-column label="上账方式" slot="errorReason" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.upType=='00'">系统自动上账</div>
          <div v-if="row.upType=='01'">人工确认上账</div>
        </template>
      </el-table-column>
    </GlobalTable>
    <!--导出弹框-->
    <el-dialog title="操作提示" :visible.sync="codeShow" :close-on-click-modal="false" width="500px" @closed="code = ''">
      <div style="font-size: 14px;margin-bottom: 20px;">
        <div style="margin-top: 10px;color: #333333;font-size: 16px;text-align: center;">是否确认导出？</div>
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 10px;">
        <div style="width: 88px">动态口令：</div>
        <el-input v-model="code" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="codeShow = false">取消</el-button>
        <el-button type="primary" :loading="isExport" @click.native="codeSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {_http} from "@/utils/request/rechargeRecord";
export default {
  name: "Table",
  props: {
    // accountType: {
    //   require: true,
    //   type: String
    // },
  },
  data() {
    return {
      isExport: false,
      sdcommShow: false,
      params: {},
      loading: false,
      butLoading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      tableColumns: [
        { slotName: "bizType" },
        { label: "交易时间", prop: "rechargeTime" },
        { slotName: "relationNo" },
        { slotName: "bankAccount" },
        { label: "交易金额", prop: "rechargeAmount" },
        { label: "付款姓名", prop: "payerBankCardholder" },
        { slotName: "payAccount" },
        { label: "付款银行", prop: "payerBankOpening" },
        { label: "交易备注", prop: "rechargeNote" },
        { slotName:"getWay"},
        { label: "信息获取时间", prop: "createTime" },
        { slotName:"accountType"},
        { label: "上账商户", prop: "enterpriseName" },
        { label: "上账时间", prop: "upTime" },
        {slotName:"errorReason"}
      ],
      // 弹出框
      bizType: "",
      codeShow: false,
      code: "",

    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
  },
  mounted() {
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.page.pageNum = 1
      this.handleCurrentChange()
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      console.log(this.SeachParams, "SeachParams88888")
      this.$emit('params', this.SeachParams)
      if (!this.SeachParams.startTime) {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
        return this.$message.error("请选择交易时间")
      }
      // if (!this.SeachParams.startTimeInfo) {
      //   if (typeof this.SeachParams.disuseLoding == "function") {
      //     this.SeachParams.disuseLoding();
      //   }
      //   return this.$message.error("请选择信息获取时间")
      // }
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      }
      const baseRequest = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "01",//待上账 01上账
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: this.SeachParams.merchantType,//商户选择
        enterpriseId: this.SeachParams.enterpriseId,//上账商户
        upType:this.SeachParams.accountType
      };
      this.loading = true
      _http.getList(baseRequest).then(res => {
        if (res.code === 1) {
          this.seachDataList = res.data.list.records;
          this.page.total = res.data.list.total;
          this.page.pageNum = res.data.list.current;
          this.loading = false
        }
      }).finally(() => {
        if (typeof this.SeachParams.disuseLoding == "function") {
          this.SeachParams.disuseLoding();
        }
      });
    },

    // 导出
    clickExcel() {
      this.codeShow = true
    },
    // 导出账单弹框确定
    codeSubmit() {
      //未识别
      if (!this.code.trim()) {
        return this.$message.error("请输入动态口令");
      }
      const params = {
        outUniqNo: this.SeachParams.transferNo,//交易流水号
        payerBankCardholder: this.SeachParams.relationNo,//付款姓名
        payerBankCard: this.SeachParams.staffName,//付款账号
        getWay: this.SeachParams.staffRole,//交流信息来源
        payeeBankCard: this.SeachParams.bankAccount,//收款账号
        upState: "01",//待上账 01上账
        payeeBankOpening: this.SeachParams.bankName,//收款银行
        rechargeTimeStart: this.SeachParams.startTime,//交易开始时间
        rechargeTimeEnd: this.SeachParams.endTime,//交易结束时间
        createTimeStart: this.SeachParams.startTimeInfo,//信息获取时间开始
        createTimeEnd: this.SeachParams.endTimeInfo,//信息获取时间结束
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
        accountType: this.SeachParams.merchantType,//商户选择
        enterpriseId: this.SeachParams.enterpriseId,//上账商户
        upType:this.SeachParams.accountType
      }
      this.isExport = true
      _http.excel(params).then(res => {
        console.log(res)
        // if (this.SeachParams.startTime) {
        const content = res;
        const blob = new Blob([content]);
        let reader = new FileReader(); // 创建读取文件对象
        reader.addEventListener("loadend", () => { //
          try {
            let data = JSON.parse(reader.result);
            if (data.code === 0) {
              this.$message.error(data.msg || '导出失败')
            }
          } catch (err) {
            const fileName = "已上账商户充值记录.xlsx";
            if ("download" in document.createElement("a")) {
              // 非IE下载
              const elink = document.createElement("a");
              elink.download = fileName;
              elink.style.display = "none";
              elink.href = URL.createObjectURL(blob);
              document.body.appendChild(elink);
              elink.click();
              URL.revokeObjectURL(elink.href); // 释放URL 对象
              document.body.removeChild(elink);
            } else {
              // IE10+下载
              navigator.msSaveBlob(blob, fileName);
            }
            this.codeShow = false
          }
        })
        reader.readAsText(blob, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
        this.isExport = false
      }).catch(err => {
        this.isExport = false
        console.log(err)
      });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">

.GlobalTable {
  .qb_act {
    display: flex;
    margin: 10px 0;

    .qukliy_box {
      font-size: 13px;
      margin-right: 10px;
      line-height: 13px;
      border-radius: 5px;
      padding: 5px 10px;
      background-color: #e4ecfd;
      color: rgb(9, 129, 255);
    }
  }

  .generated {
    margin-left: -30px;
  }

  .ga_content {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  // 备注说明
  .enable-tip {
    color: #FF8080;
    font-size: 14px;
    margin-bottom: 20px;
  }

  .el_from {
    margin-left: -120px;
    margin-bottom: 0;
  }

  /deep/.el-select {
    width: 100% !important;
  }

  .command {
    display: flex;
    align-items: center;

    /deep/.el-input {
      width: 300px;
    }
  }

  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .openSytle {
    padding: 20px 10px;
    background-color: #F5F5F5;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }

  .button_top {
    margin-bottom: 20px;
    ;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .faultBtn {
    width: 280px;
    height: 34px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;

    .active {
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981FF;
      border-radius: 20px;
    }

    .none {
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }

  .verify-title {
    color: #0981FF;
    line-height: 16px;
    font-size: 16px;
    padding-left: 10px;
    border-left: 3px solid;
    margin-bottom: 10px;
  }

  .repair_dialog {
    /deep/.el-dialog__body {
      padding: 0 20px 0 20px;
    }

    /deep/.el-loading-mask .el-loading-spinner {
      margin-top: -35px !important;
    }
  }

  .repair-conent {
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .verify-mark {
    width: max-content;
    font-size: 12px;
    color: #fff;
    padding: 0 6px;
    background: #FF687B;
    border-radius: 10px 8px 8px 0px;
    margin-left: 10px;
  }

  .mb-10 {
    margin-bottom: 10px;
  }

  .mb-20 {
    margin-bottom: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .flex-ac {
    align-items: center;
    justify-content: flex-start;
  }
}
/deep/
.mycommandform1 .el-form-item:nth-child(2) {
display: flex;
justify-content: flex-end;
}
// /deep/.mycommandform .el-input {
//     width: 300px;
//   }
  </style>

